import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private data: any[] = [];

  public setData(id: number | string, data: any) {
    this.data[id] = data;
  }

  public getData(id: number | string) {
    return this.data[id];
  }
}
